import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

/**
 * The LaunchDarkly flags this package reads: the ones a route's availability names, and the
 * permissions rollout switches. Each availability flag is declared by the feature that owns it too —
 * `useFlags` serves one flat set, so redeclaring the name here types the read without this package
 * depending on a feature package.
 */
export const useRouteLdFlags = createFlagsHook<typeof import('./flags.json')>()

export type RouteLdFlagName = keyof ReturnType<typeof useRouteLdFlags>
